export function PlotRequest_toTransferable(kind, req) {
    return {
        request: { ...req },
        kind: kind,
    };
}
// There is no point for - from transferable function in this case
export function PlotRequest_fromTransferable(req) {
    return {
        request: { ...req.request },
        kind: req.kind,
    };
}
//# sourceMappingURL=PlotRequest.js.map